import { PackageProcessServiceBase, WsPackageProcess } from "./wsdl/WsPackageProcess/v1.07/WsPackageProcess.ts";

export {
    type WsPackageProcess
};

export class PackageProcessService extends PackageProcessServiceBase {
}
